import { z } from "zod"

const personalInfoSchema = z.object({
  phone: z.string().min(1, "Invalid phone number"), // Validates a phone number format
  name: z.string().min(1, "Name is required"), // Ensures the name is not empty
  email: z.string().email("Invalid email address"), // Validates email format
})

export default personalInfoSchema
